import { render } from "./ItemSignUp.vue?vue&type=template&id=748f0660"
import script from "./ItemSignUp.vue?vue&type=script&lang=js"
export * from "./ItemSignUp.vue?vue&type=script&lang=js"

import "./ItemSignUp.vue?vue&type=style&index=0&id=748f0660&lang=scss"

import exportComponent from "/Users/anwarfuadi/Documents/nyp/gigihpack.com/fe/gigihpack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__